import { Injectable } from '@angular/core';

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

import {
  AuthorizedDriverFormData,
  EmployeeFormData,
} from 'src/app/models/employee-driver-license-and-information.model';

@Injectable({
  providedIn: 'root',
})
export class ConsentPdfService {
  constructor() {}

  generateHTML(
    authorizedDriverFormValue: AuthorizedDriverFormData,
    employeeFormValue: EmployeeFormData,
    company: string,
    employeeStateProvince: string,
    authorizedDriverStateProvince: string,
    authorizedDriverRelationship: string
  ): string {
    const html = `<!DOCTYPE html>
<html lang="en">
  <head >
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>
      ${employeeFormValue.lastName}_${employeeFormValue.firstName}_${
        authorizedDriverFormValue.lastName
      }_${authorizedDriverFormValue.firstName}_consent_document.pdf
    </title>
    <style>
     @media print {
        @page {
          size: a4;
          margin: 0.3in;
        }
          body img {
            visibility: visiblity !important;
          }
      }
    </style>
  </head>
  <body >
    <main  style="font-family: sans-serif !important; font-size: 9px !important; min-width: 180mm !important;">
      <header>
        <h2 style="text-align: center;">
          BMW Group Employee Vehicle Program
        </h2>
        <h2 style="text-align: center;">
          Motor Vehicle Report Monitoring Consent Form
        </h2>
        <p style="text-align: center">
          Vehicle Administration in conjunction with SambaSafety continuously
          monitors your Motor Vehicle Record (MVR).
          <br />
          If there is a change in your MVR, it will be reviewed.
        </p>
        <br />
        <!-- <hr /> -->
        <!-- <p class="warning">* THIS FORM MUST BE SIGNED *</p> -->
      </header>
 
      <section  >
        <!-- First table -->
        <table
         
        >
          <table
            style="
              width: 100%;
              border: 2px !important;
              border-spacing: 0;
              margin: 0px auto;
              border-collapse: collapse;
              border-spacing: 0;
               font-family: sans-serif !important; font-size: 9px !important
            "
          >
            <tbody style="border: 1px solid black; padding: 1%;  ">
              <tr>
                <td
                  rowspan="3"
                  style="
                    border: 1px solid black;
                    text-align: center;
                    writing-mode: sideways-rl;
                    transform: rotate(180deg);
                    width: 0%;
                    overflow: hidden;
                    padding: 10px;
                    word-break: break-all;
                    white-space: normal;
                    word-break: keep-all !important;
                  "
                >
                <img id="" style='width: 6px; transform: rotate(180deg);' src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAFhCAYAAABu2Lp4AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAsXSURBVHhe7V2tk7s8ED6HrERWViJPIisrkcjKSv6Ek0gksrISiaysRFYikch9N3xlgbAEaDv3uzfPzM7NXIGHhmS/Q7/gQzBEq2GIVuO3EZWQP24QXnzwjw7Ytr1QLhpERQqXwxd8fW0Rb44og9BRnbhUZojK66l/guXA0Q8gut3gtkgeHFEJ16Mk2Xk3KJpP1oAhusPZar/JGdLmv2vBECXgtUPmJc3/1uM3ED3ljDte8YltA0OEkzvY10RfJ7huZGKJoLiB10yIHQ7fm2ZdjSLxwW6elX0MIc3XfTWGKIdHs+Dis9MMYSs7hT7jhNV1ZNZtFlYFfYxIDt12YXXda2GI0Hrgs0siCHw061QuIVyTBzwL9TrTJyruEJ5sxYwai+X4cHv2CbWIivQMe8UFebHBT6TSmifKQnBGF9nBwfV6Q3d0bNiNjnMgzOrLzBA9INiTE3cuhGnOmIwSnkkA7o6csw/QxZkh6jknOw/ISPAoUKsQMmE3WaLEaw/eQ/Bo/qmLRyCfKzIxRDhsdnPgIUR7uxRooVvH8/DDEW33GeSI6Grv9xKRoXNj1OVLkUPsNufbAUdEPdUDhEsf0jOEQ3UuCnpRDNFgejthtR700A8O3DjniSq3uLf4UIdlvHNSZjfwe4v8jFfRUEFF4o1Vy05EFT4EUWNBowDV0BEcelOV7HCx1qt8lkggi12FHpuTHQ6ZHGwtIoHiHoGnG/kdVpoJijJL4RpeBrHsAVzPh0t4g8eEg7mYaC3+IFFMrKTvx6h4Wjyg/9kWiVFf9mYMGreGpqdUNwsq1Y8RfWzomqu+Hb+BqIQizyEXMuHmzqHIklrhehFH9Pd8hvVEZYHD/QjBbXNJX74gKpHZav7xJkHnpv5GeQyu6oCXyA6jilIO3aNLx7xOdrYD/q121N46GSh+AxHJMzyW+6lDMESvxUeIyuypT1QWGaRdymVaKg+pNQ+eC4fKqWQ1Q4Myg+ioF/ZPyywRCT02SaWCGKRnsHon7MA+uOB538RFJknCoe99/IE0K6ooniVKfHlSP5NPYqcmvG9R5ikE3+15WnkGEux+HeE6CP2f4UFebBSkkfioiRYZIqIZVHnvBMe9+Ry/7Bhd+G/BOdUlUqkgDB3b1M3hRxULyhjYOt83EGnows7CHkKOiETlygvRhIU64aFpyvvhuypDcyMXUj0mTSI6syx84OOMU/YjPxcPvA8yIrMLNo/guzpQCMakQQK9oPxOFrTzQz4r8SZI9r/zGSaBjou/kycIsepwvgbeNQ318Wac4zg6/45m8wwCuPi6lY7i9B+8Mj1ARTfPUKOE5+0CrhhzxQzM4mNXkemJfYQ2A6BJJFGWE354gWFOIGyQBx7aoiB+9OpNi4nW4n9LJKr/CUTiGXTh4hLRCS2zGI7dCl8rcz7DIH+9XmaIZB22Fss5VkPR5em0ha2IZfDTmXILjvE2t5ghIobtO6rs/hboEU1Y0CXQG7r3Eglz08S2ExZ2CVgiGtuK3PUW8EQIaW/Qwob31R0As0QC+fVEjJtV+98jNcOJjgrKr3D6syqoLRWoh4cTduioCtrBKX6OHf0FYIj+ngqac/KXgZ0Mn1NBpE7nRssrsRQ8ESILW2f9bSqozRJncOv1BaEKaky6vrDriMy6zcJqho8R/cnaRJHBY1B9XAuWqF2wlnOB+0Y+hoho70FiaQ0Yoo8pVdKnqswqLQP7jNJWqSrSaEvBEvV8Bo0WAw4MUaPrshucaYe0ZY+6nObF6LrV8mt03Qvxi4lMD2SDeSLTAylgeiC3mvK3txm00CQiQ2d6IPFI0wNZ4d/qgSyLusSsi9U9kK2asPxkEeFSfPnt1x2t/u2agUI28n2MaJTBejERXcH7U+PJVImMK5xaotO1bn9bLQV8jbKMb5FKe79q4yYnnZko4B754B7adSGEFnqX7gkbiu4esVdMhuavAh8jIvFRvDX/yBK9Fr+QqApXWiMnfW490Qotc7j5bSfGWmHdLYECfbNB48QqmSMa9W7VDZTLCyEzQyc9TRQngPuGfBBDRDzV9yadqGZ4axrtYyqIFnzfnBjsqi3v3SmPIK1tThterwRPhPhgtSWHNKDVFrS2ptrCE5kMJA9DtBpfF6UL+2pBl/h1a4UTXEcfI3rdouTELNgNMESrYYhWwxCthiFCoKucpVW+u27LpruCMYbPHqDK3+oTlU+4+c4oeBZGTYZpbT3DhuMgINAiKu4B2agxFEpE9yxhBC8yl80n80QTVUuZ2adEKXRZ50b2Tc1uhmhQtRQZ+qYIQotQvQi3zCDuFYa/IcKvxRJxZZ1Jogr9jMs+yHgiue2nvisKnghRkiwzv4mGL73NEnUzEAWDbYaIzzPME/WP+Q1EW4cukzOWL/jSi42rlnNEZeJJLYIjwhKtnt6irkHqfacr2YWtBm1cRiFVSyWRyLvGfr/JYl83084QIVQqyKJNEntwRcWyV2JoRbtxokaJZNNKdUr2cE6l/tYiqlDcIfJUZmIs9ikcpUX1iVqUBWRpa/SoBBAlaqMnsJxoJRgi88aJMd5OZN44sVnMGyfMGydGMG+c2CDmjRME5o0T64k0dGFnYc0bJ4Ywb5yYgXnjhHnjxIth3gO5UpDoY0PXXPXt+KVEZQ4Z8xMDj/gC4TXta/gGekR0S9CE2Rb6UG4WsMC59H9kYZ5o+KKBgfaWGGTCmmNbt2WGCP2CYVeufZnoesohCbxaw5Pj25+PYIl6iUF0FAPNBjtRYpCpt3oDDksknYs6sl6C4iZTnTN+HXEuVr3NwOzWEQcq8t7z0N6tQz3RAyj9eA7UJ1y2W2dJ+2i/K14j7z3YrYPuU5Bk41ipQwl5GvZfzaTr15UYcI0dRKuKWZ1jY2+a7SfjDLJcf7NEAkWyZgvk2/PeqLm96AV5b3wOVcH3GsKFmGux6Sl5PGEqobyCaB1+MZHZ4dtgnsjs8BUwO3yNz9CH2eHbW3xmh68cbC0iAfMrJ0P8a0TkR1Cr2ThOAWgSCYMWgu8ewL4MQ+UMVY2qDcRG514qrnkidEpkmQZloPfuZ277nfY6UlTEaFZ/VPq2cfYNUwD1T1XyRIOK2MELIWkqXAI5LmR5QVpj6re9zea9u61bKO6w723wba1RzSCVL5/itTcxxar3bpVXODYkQlS2sQtNt7S94dh0JNWwKRTCS0z5IyDu8bb6USI7NEdEZFhRbKUvpt0xSDJbw0JVr9xjwVmWXyT0eyBxzXddG7RQNdgjq9xMuLCrs3/nIhxxR/k4cREJVFVpBH7PbtWODU+EkBsGFTLyx4mL1ki7o3GWSNxlFinqQ8KKjpw96qKhJkEF3N6HBlGDsoDnI0FnBE0A08uV/Xxj+I+qaqspX4t/jchY2BGMhaUwFnaCyFhYhshYWAFjYd+A9xJVuw5EU8xcA9JKlFkCYa+OwWqGhejuXk4GKS8gGt+9SlYPHU75JJj9RYCd40HYVNAWEZX5A+KLq+5qasV24bLOCxJ3H4LncF3uNnxf4sk8kMAkkdbdt6KRrh4Qady9GJpY7PgghlGbqMwgCT2ZbB0JulGXCNLewC8kitzpmhCdNWMsJOoObgWHxg8HLYhKrCbaw0kQaO9j2fqNhFhil5TwSjnShUR1lMDU7iaHciFR87ebeePctRTbvUCUtpNjLRHBvKIU092Tjstaog5im9as+kFBw5Yw6keAJyIQKukmhrbb6qOQCYUqoE0kIeLVGC7unrVB4tefRAtp+0VXEBGwVlXKzpnZ1LkEvLZ/pc/QAS0AusWX3tp8CxFBtTb997lbYwD8B2BqMGSVspwpAAAAAElFTkSuQmCC">
 
                </td>
                <td
                  style="
                    width: 5%;
                    border-color: black;
                    border-style: solid;
                    overflow: hidden;
                    padding: 10px;
                    word-break: break-all;
                    white-space: normal;
                    border: 0px;
 
                    word-break: keep-all !important;
                  "
                >
                  Associate Name:
                </td>
                <td
                  style="
                    width: 15%;
                    border-color: black;
                    border-style: solid;
                    overflow: hidden;
                    padding: 10px;
                    word-break: break-all;
                    white-space: normal;
                    border: 0px;
 
                    word-break: keep-all !important;
                  "
                >
                  ${employeeFormValue.firstName}
                  ${employeeFormValue.middleName} ${
                    employeeFormValue.lastName
                  } ${employeeFormValue.suffix}
                </td>
                <td
                  style="
                    width: 5%;
                    border-color: black;
                    border-style: solid;
                    overflow: hidden;
                    padding: 10px;
                    word-break: break-all;
                    white-space: normal;
                    border: 0px;
                    word-break: keep-all !important;
                  "
                >
                  Associate No.:
                </td>
                <td
                  style="
                    width: 5%;
                    border-color: black;
                    border-style: solid;
                    overflow: hidden;
                    padding: 10px;
                    word-break: break-all;
                    white-space: normal;
                    border: 0px;
                    word-break: keep-all !important;
                  "
                  colspan="2"
                >
                  ${employeeFormValue.employeeId}
                </td>
                <td
                  style="
                    width: 5%;
                    border-color: black;
                    border-style: solid;
                    overflow: hidden;
                    padding: 10px;
                    word-break: break-all;
                    white-space: normal;
                    border: 0px;
                    word-break: keep-all !important;
                  "
                >
                  Telephone:
                </td>
                <td
                  style="
                    width: 5%;
                    border-color: black;
                    border-style: solid;
                    overflow: hidden;
                    padding: 10px;
                    word-break: break-all;
                    white-space: normal;
                    border: 0px;
                    word-break: keep-all !important;
                  "
                  colspan="2"
                ></td>
              </tr>
              <tr>
                <td
                  colspan="8"
                  style="
                    width: 5%;
                    border-color: black;
                    border-style: solid;
                    overflow: hidden;
                    padding: 10px;
                    word-break: break-all;
                    white-space: normal;
                    border: 0px;
                    word-break: keep-all !important;
                  "
                >
                  Note: Please provide driver’s license details below for each
                  vehicle request. It is the associate’s responsibility to
                  advise Vehicle Administration or Human Resources of a
                  suspended or revoked driver's license, in writing, within 48
                  hours of DMV notification.
                </td>
              </tr>
              <tr>
                <td
                  style="
                    width: 5%;
                    border-color: black;
                    border-style: solid;
                    overflow: hidden;
                    padding: 10px;
                    word-break: break-all;
                    white-space: normal;
                    border: 0px;
                    word-break: keep-all !important;
                  "
                >
                  Driver License No.:
                </td>
                <td
                  style="
                    width: 15%;
                    border-color: black;
                    border-style: solid;
                    overflow: hidden;
                    padding: 10px;
                    word-break: break-all;
                    white-space: normal;
                    border: 0px;
                    word-break: keep-all !important;
                  "
                >
                  ${employeeFormValue.driverLicenseNumber}
                </td>
                <td
                  style="
                    width: 5%;
                    border-color: black;
                    border-style: solid;
                    overflow: hidden;
                    padding: 10px;
                    word-break: break-all;
                    white-space: normal;
                    border: 0px;
                    word-break: keep-all !important;
                  "
                >
                  Expiry Date (mm/dd/yyyy):
                </td>
                <td
                  style="
                    width: 5%;
                    border-color: black;
                    border-style: solid;
                    overflow: hidden;
                    padding: 10px;
                    word-break: break-all;
                    white-space: normal;
                    border: 0px;
                    word-break: keep-all !important;
                  "
                >
                  ${employeeFormValue.expiryDate}
                </td>
                <td
                  style="
                    width: 5%;
                    border-color: black;
                    border-style: solid;
                    overflow: hidden;
                    padding: 10px;
                    word-break: break-all;
                    white-space: normal;
                    border: 0px;
                    word-break: keep-all !important;
                  "
                >
                  Issuing State:
                </td>
                <td
                  style="
                    width: 5%;
                    border-color: black;
                    border-style: solid;
                    overflow: hidden;
                    padding: 10px;
                    word-break: break-all;
                    white-space: normal;
                    border: 0px;
                    word-break: keep-all !important;
                  "
                >
                  ${employeeStateProvince}
                </td>
                <td
                  style="
                    width: 5%;
                    border-color: black;
                    border-style: solid;
                    overflow: hidden;
                    padding: 10px;
                    word-break: break-all;
                    white-space: normal;
                    border: 0px;
                    word-break: keep-all !important;
                  "
                >
                  Birth Date (mm/dd/yyyy):
                </td>
                <td
                  style="
                    width: 5%;
                    border-color: black;
                    border-style: solid;
                    overflow: hidden;
                    padding: 10px;
                    word-break: break-all;
                    white-space: normal;
                    border: 0px;
                    word-break: keep-all !important;
                  "
                >
                  ${employeeFormValue.dateOfBirth}
                </td>
              </tr>
            </tbody>
          </table>
        </table>
        <br />

        <!-- First table -->
        <table
          style="
            width: 100%;
            border: 2px !important;
            border-spacing: 0;
            margin: 0px auto;
            border-collapse: collapse;
            border-spacing: 0;
            font-family: sans-serif !important; font-size: 9px !important
          "
        >
          <tbody style="border: 1px solid black; padding: 1%">
            <tr>
              <td
              rowspan="3"
                style="
                    border: 1px solid black;
                    text-align: center;
                    writing-mode: sideways-rl;
                    transform: rotate(180deg);
                    width: 0%;
                    overflow: hidden;
                    padding: 10px;
                    word-break: break-all;
                    white-space: normal;
                    word-break: keep-all !important;
                "
              >
                                <img id="" style='width: 8px; transform: rotate(180deg);' src="data:image/png;base64,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">
              </td>
              <td
                style="
                  width: 5%;
                  border-color: black;
                  border-style: solid;
                  overflow: hidden;
                  padding: 10px;
                  word-break: break-all;
                  white-space: normal;
                  border: 0px;
                  word-break: keep-all !important;
                "
              >
                ${
                  authorizedDriverFormValue.primaryDriverInd === 'Y'
                    ? 'Primary'
                    : 'Authorized'
                } Driver Name:
              </td>
              <td
                style="
                  width: 15%;
                  border-color: black;
                  border-style: solid;
                  overflow: hidden;
                  padding: 10px;
                  word-break: break-all;
                  white-space: normal;
                  border: 0px;
                  word-break: keep-all !important;
                "
              >
                ${authorizedDriverFormValue.firstName}
                ${authorizedDriverFormValue.middleName} ${
                  authorizedDriverFormValue.lastName
                }
                ${authorizedDriverFormValue.suffix}
              </td>
              <td
                colspan="3"
                style="
                  width: 5%;
                  border-color: black;
                  border-style: solid;
                  overflow: hidden;
                  padding: 10px;
                  word-break: break-all;
                  white-space: normal;
                  border: 0px;
                  word-break: keep-all !important;
                "
              >
                Relationship to Associate:
              </td>
              <td
                colspan="3"
                style="
                  width: 15%;
                  border-color: black;
                  border-style: solid;
                  overflow: hidden;
                  padding: 10px;
                  word-break: break-all;
                  white-space: normal;
                  border: 0px;
                  word-break: keep-all !important;
                "
              >
                ${authorizedDriverRelationship}
              </td>
            </tr>
            <tr>
              <td
                style="
                  width: 5%;
                  border-color: black;
                  border-style: solid;
                  overflow: hidden;
                  padding: 10px;
                  word-break: break-all;
                  white-space: normal;
                  border: 0px;
                  word-break: keep-all !important;
                "
              >
                Driver License No.:
              </td>
              <td
                style="
                  width: 15%;
                  border-color: black;
                  border-style: solid;
                  overflow: hidden;
                  padding: 10px;
                  word-break: break-all;
                  white-space: normal;
                  border: 0px;
                  word-break: keep-all !important;
                "
              >
                ${authorizedDriverFormValue.driverLicenseNumber}
              </td>
              <td
                style="
                  width: 5%;
                  border-color: black;
                  border-style: solid;
                  overflow: hidden;
                  padding: 10px;
                  word-break: break-all;
                  white-space: normal;
                  border: 0px;
                  word-break: keep-all !important;
                "
              >
                Expiry Date (mm/dd/yyyy):
              </td>
              <td
                style="
                  width: 5%;
                  border-color: black;
                  border-style: solid;
                  overflow: hidden;
                  padding: 10px;
                  word-break: break-all;
                  white-space: normal;
                  border: 0px;
                  word-break: keep-all !important;
                "
              >
                ${authorizedDriverFormValue.expiryDate}
              </td>
              <td
                style="
                  width: 5%;
                  border-color: black;
                  border-style: solid;
                  overflow: hidden;
                  padding: 10px;
                  word-break: break-all;
                  white-space: normal;
                  border: 0px;
                  word-break: keep-all !important;
                "
              >
                Issuing State:
              </td>
              <td
                style="
                  width: 5%;
                  border-color: black;
                  border-style: solid;
                  overflow: hidden;
                  padding: 10px;
                  word-break: break-all;
                  white-space: normal;
                  border: 0px;
                  word-break: keep-all !important;
                "
              >
                ${authorizedDriverStateProvince}
              </td>
              <td
                style="
                  width: 5%;
                  border-color: black;
                  border-style: solid;
                  overflow: hidden;
                  padding: 10px;
                  word-break: break-all;
                  white-space: normal;
                  border: 0px;
                  word-break: keep-all !important;
                "
              >
                Birth Date (mm/dd/yyyy):
              </td>
              <td
                style="
                  width: 5%;
                  border-color: black;
                  border-style: solid;
                  overflow: hidden;
                  padding: 10px;
                  word-break: break-all;
                  white-space: normal;
                  border: 0px;
                  word-break: keep-all !important;
                "
              >
                ${authorizedDriverFormValue.dateOfBirth}
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <!-- Second table -->
        <table
          style="
            width: 100%;
            border: 2px !important;
            border-spacing: 0;
            margin: 0px auto;
            border-collapse: collapse;
            border-spacing: 0;
            font-family: sans-serif !important; font-size: 9px !important
          "
        >
          <tbody style="border: 1px solid black; padding: 1%">
            <tr>
              <td
              rowspan="3"
                style="
                   border: 1px solid black;
                    text-align: center;
                    writing-mode: sideways-rl;
                    transform: rotate(180deg);
                    width: 0%;
                    overflow: hidden;
                    padding: 10px;
                    word-break: break-all;
                    white-space: normal;
                    word-break: keep-all !important;
                "
              >
                                                <img id="" style='width: 12px; transform: rotate(180deg);' src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAKsCAYAAACj0p7sAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAABoqSURBVHhe7Z0tm7M6EIZfh0RWVlYiK5HISiSyspKfsBJZWVlZWVlZWYmsrEQi5yR8DjTlKxMaevJc15jd7i73EsJkZjL5Bz8mA6S71AClCcS3M0SHAHx3A6vV6s02rg9BeITLLYYkLX6OQHRAaQzXKAB3bcG/f/9Gm7V24XB6wEsSThoofd3g6DtgCS5ymlngBCd4JMUfGKnpQOkTLsFGcEG52asNuH6QD6vLpWX5cAw8hw2/z3d0E1wgHnnHJgCl8LwEsGlfgO2Axy7+FifsEyPFnrnn4wJR4MLaav3efyvwjvHg3zkOKLlD5Nroj7Hh4UdwHftv7FQKr8cJDu4K/R1m2xDuA4bhCKAbBOgPbCTG+WAlDzg1hnXArqJbI4Cu4LNfuvJCuD4p78gA8ZHh8Tvms6vo1gigJ9yH3HOFSu53dhXdmjAp6C0DpLvmB2Iv5MxF2uQ+ncMmmRPhdEkPxD2IQ/GC9FtzUnKFYFVP/djW+xtQYNECxSdwbXShToRmpQTOHvqewJwoLj47XYRADwjXrYu09nAvvgvPqOkubXyIzsyn8/GLcwvHV/H5iSIDSs87dGFrCFpLgWeELpyB4jd+HDnV99ah3F0iA7r6JYwN+1vbk3hCtCm/z7yN8FF8vRS7u+Wz5Z5A5iYRAcXwV17w9vh+QS/2bBUw3KHdV+OwVv0PCXrdmy4RAeV+XnZB7ZmNKT17xcVy8+FSfB2rBur317o0C9B9jxZxH4aUZkB32JcLM7/9/0fPB7NNJHIvX3Byi8+sQvYT00UEhC6oNYNBHMK6gOGrz7f5gOt1hG35Ge88fsWLRATEr2lbXDR7QYb3/K2fssnCKWGYrUM2fbTU+sxW8kVEBsSefNiVF56Z9RYJal7sC66h14pNeHCW9H/ogJiSqw924wKRMTeoeXfQVJ+ZDf5V3psjBeJK7hHsGg4oj7NdQLRqv1Qz2waCi9xQK0UOVClN4PXqDmm9riGEBNFSLHVAX9L/GegGfx+ehVmUhZ7/6ONy+QM8PDQrrxTiKvRMHJc74TDwyoPw+lQIxkEOsMUzJvPkieNyCdwjD1blH+BmOeBH19FZgk9KXw84Hdzm32DvKDcqvI8eTZsUXhcIGi/F3HjSyg+PcH08B2fl0uRVZPs8cHA8orRNAJcRD+40oEwpPNl7xPsQxcnNzlOQjgdBEFTmOXkIqzNJNnFISwCVYmOdgTW9g+lmOT5EEs8mAVCtbPwzh1M4dDrMWvHn8AIPApeBFKgh7vrEtzr9iIZccIjgfLnALX6RZsC51AF9SXRAMbsTs75wxSIDqoMcO+lFmoyIgFAgRBSXm1FEQN1hrDlFf4ckozayInuG4nBdPEMb+JPPikwWGRAPekTb4i7xJQbx0nqoiIBe8OA1POcj7HEcjptVl5QNs0PvIq5L9JOCtOkWrJc2LYCKIUdi7NkrfusUEU4KesgA6S6lQHzBdz2GaNndnJIfZ+riQUVA6VMcRGnOYHWSbOUdyaJG5EDxyf2cUmkANVP9/9Z7uBEsO0iB3vNDVhbxcasKEwx0h0MrsGL5F+l6HzqglL1cUUXvGsXBP2e4U4iP+I6uQbKQhA4I51httibC/+m+lD0ujbFEVRkjRASUokortgRvPeD9NQi3uiygUcE1XkRAqE5BsMAbUlRRpycXUBozBGjIZ4bIAImFUvSb92eg/2LRMyT4+TEiAsIFSvZb+Vgf0Iu9jPPvazPLMd32dXrE9uGC5u0uoOS6R7VAFuxl1t9MdEDszdMskq0DJe9AKSTxtVVvykyympGLEIgpYZNDTyrFXuHtOsjYXSWojCEG4kpucBB62h22Yi9jovgxPVCmBB6nA7h9WT2ecD4OSwYPlSKgWnlSuB0IuUFMnekqpBxobhEB3eF44BsK1fzXx4gICLk+KxcCwkKMsaIHQmZnKfp505REQA84eV27jW0F20PFIp4UeBFGBEF7Dyq2sjZocbNc+srfRR2b3fOqEV1363coTfhOfr+jwiTfsXx5vKSft1mAsNL4xqZ40Z7vwtqV+SM1O1CtwuMO2pPJp0XgMH0HiHfEyCaPtWBmXAwQmwFvRzgIIXLLu16wSaL4iSlSDMRbCVzYQs75HO+21uAeTiSlZVxKgMoHv1k3is2CtXuAE8Gs1hYZEM8FXfjU/Gn2YmY5HvnWgLaIgMS+XGbMM/BCuiHVJ0VA7EWZ7fGmH1J9IgWaY0j1iQiIb635IgUS2aSgi/7PQDc4fKyaan9PxmarxmrPZNjn6pi2R9tsvtzPAbUrrnDVlKnGUiY6IFNZr0ZEQKayXpno75CprKcVGRCvVTCV9UIzlfUNGSCxjC+nTAZIdykB4sUWr1fLFKUg2yIBqvaAd3Rmzs2C1UZt2l8KKNsS4PRBfLbVLhrU0HiMJgK1C8hlbE3WpIhrEhAuHMdmOx4cojN7l1zh8ayfn+fjyr7Gd+37H7LiNrgnGo92NFB6Dd7uzNjO5dkz99ZNfS1u1TZSI4HYuqfR+tOBUOIhSOOo7ivHjWC1Ow4IF8ry6t+3bpkTdN9/bzMH7rVosaU2zcybwnlXAolaho7TCKAnRGitQxk6aHTZnK+lIYobsBWpsHfkVOG2u5u/VmO9cRoBhNc8cmuWd13IfrcmQHS/2wAZoEEyQB9lgPI/uoWDMGIz1Q7Ip/sKkEozQA39n4GWIQOkuwyQ7jJAussA6S4DpLsMkO4yQLprBBDP6bTaTCuxE/tL0zUCyKxYJ9psQEOG3K51nhDfR3SA6HzJzv/Ocq5Vl3SvtRvMgf2JR4A0qvVpHNA36FgSfo4Eyqa/nVE0XnRAj/qsrnY7tj7hf8Su3fpspMiAqrrtSVufUSspPU4qRNm9t2PjhqkuZF9AO7Yheu/ONE1kQNWZ4ZOSvs1z9GTafREBoQuacqYqmlBmzIJ3Czed/Of8DS+VSS6NflrazHLttqD56TQd22+yFh/lyU+FreXOkeSiA2L6dLCfzQvMiyN78p7BooosBwiONKYF4kouQccu/Q9mu3AkKnEkB8qUcL+vo4dCZSvYhVfSk9vUAFXifUe4M3qEsHRgs6N6eIFg9ymGU6UYaH4ZoDEyHdEJRA5kOqKjz5uO6AKRAZmO6A2ZjugfRQTUvQQfAjTkM0NkgMQyHdEbMh3RO0QHxN48piM6NtMRXSx6oEymIzqZlAPNLW2AePvQ/O5pkZKs27G54bRnot+bGCYiIOTLMbPZ+2TsOk1roMzW+1HvFf2BMttCNDCcoy3Qxt+D2/AWVrAb8NbUF4jvB2Uu0L6xxfofrJnX2TUCtQWqdgqnMRzdpt9mu58Divo+Q40Va8JWFWXPrMI++G0LAcr1Hk3dvu3yXxQQV3IPwamAuNngHuscbPxXro0WApTpdYZda7203udByWe0RCCu5A5h1bYtN+5ZXBZ5hyq94Lz7dBzJIoG4UogjVKxR2WKBcr2XAWgBhNqxPcavZtL4iNwlLYD0kQHSXSOATEf0iTbbpPBzQO1OmTjcZLpoKhMdkOmIrkZEQKYjujLR3yHTEZ1WZEC8VsF0RBea6YjekAESy/hyymSAdJdCoOKkT76juD01b1zw+aaOG713rgQouUfg9ZXFVMZewt/ut90lcXi33xyK7V1MpECiLWt1U/F6aj6GfHNHu8zMBp+gvowOqL2pcBv29qNPX7dmakXyxGkuMiBcNzpu1z1zapH/5+mx7RNX1k/YmPs61l009diYiyrrJ9WNop3KK7m9rERA8kvwxWXB+6QZUHdlfb/Qbq/5OqJ3q/4Pv1fW9wqfLCAZNSID6qqs75S2u/XxsMmsJ1Ai2q0vuZGDixCIKY5a5S+58d36jldsnfYc5nGLqut13a1/D5vHhwyy92KmqSIHylTs1q+PJflkFjiDGhoNlxqgUmmSH9VTbJ/OLW8tdVV0TL1aoC/IAOkuBUBlcCQA3900gyODTIvYdqEpm6HeTAvnlKu58pxumgCl513zwlYu+OGxERwZZlrEtvESvL+KXqWIgNASnCByIyMiIPkVK5XIgKr+cr8BhE5g+5W0fl0Z7/1CaQwTCgWPbQtKKTogJhyst90Ibl8oVBgBNKyutJ194FEg0ec+29dqTlXZbK7PzwFR1iJ0malTaMgAiYWG44TdKVzP86EIQu7neoa69HPpFHmgujfWzEDCc/P57scSaHcWfP+zZe09ol29y2vubs6PqrZUkbF/iIzDNH7ItesRSE0+AzHpGXqd2BBp+F84PTLWd+PmgBeEcCGI2mszKVDJAImVQlLOXIoaEA0VEZA+MkBiUZ5NNNv5Q11Ck4K06ebLSZsWQOOHHE+G4YDK9u9e+Hdyrd+/PCng84d0qzmVUN1gxYWTTECBSQsgHvMr0zFryf7UmgChBZ4e3ZzlpdkSXF5fW4IrUXIGL4NhpkuJ5mTxxkWoHMCSbBZMBDT2xeqDu+Er1faxPdo04adxfezgKp3O1ARoBV5E02L3S0MuhGMROqYuBPz+pEAs/YDSdMnedq0065DOC2+X/GLNitHbfbkXCFTfDQyyNCDh3Xg3ax3Om30YK37s1emw7T4bz3LAC0/wICjUUASUQnyNwHdEJxKWZoHj8zO8aI+PIwXK74bbczfc7jMmJUUANOBu2CjdQrClpkuTgfrvRjmk+L1Avp5eQLzI/AQH91OPUjZLOT5EbEg1kxBaAqEjddrWO0tpCdReItjZkOKFFv0PuPZANmx9tgS4Dm1GtIg7VJu1duHQ2WlJS6B8ZrtEfuuQf2wWrN0DnN6GoaZAtfLZLvQ69tk1JgrtgZAGOJ2Ws6mPtdIeCGmM66MqWU4KVKv/BZx5El4oeN7kpAgIKY3hGgU966Ax77RuqQdCKleq77Xd2IK56rYp1eWhLzz7kCZ8SOJ32y+kUzIV20X9vyUOOXUyQLrLAOkuA6S76IBMR3Q1IgIyHdGVif4OmY7otCIDylp4mI7oIjMd0RsyQGKhbZ/SZnYaN2SAdJdCoLLpl+mILiVyINMRvTLTEV0oMiDTER3LdET/LCIg+SX4z3W80AzIdERvynRE/yw6IDxsMjMd0U1HdJHIgTItpSP6636DeMzmc707oqOH3r8UXyu1yJ4kXd6AvKdApf83UNU+d932iBcJhFx8bryfNo/cZMvqQz1Vbw+N5fZ4mzFy2liVKrNZve0ErkFX2SWFfWH5kBSnBtTvFreu+l276OtTTLe+PsuZFLr0c0AoP8Rcmm+KCEgfGSDdZYB0lwHSXQZIdxkg3WWABonHra/MUW3E44aaFuuhUi+4BGW/xammRcKLiy3PfVEQfqzpAoTzQ4XZWWNw0bDqMk2GXJ3BY+b0F12oEhEQqtv+jROicEyhHcifVwqAfiJIgtL6v3GHeGa+2DX8GycVMj3rhDFVMd8U0QExxZGT36V/NrhETSTHigioTknewhIqB1s5nuDl2WW6xbalTQvX5+eAeF2CaPhMMa2WD9+XAdJdaoGypfgRwvZzwrPn1wc8FVSdqAFK7hDthiWXLScgORmqFDlQwlauVQJ5sK0gINgmwEULJCwAtGHj+o0h5zmic1u1KwBkq9Y1ukDbhejWVUKWwvMagovqTXnJjSwTGVDjKHqbve2HjqCEeRkISnZ9SAZUB0nWEI591T/C+rmTJCICQkGS3yhEl48pmL0PH0Q/5H5juw3eELWBaOxD9IzqCns9NkS1pm1n+pY1V/KIKDKgbJdX4yXJfLSsk/NnpfEFgsbLWO5wWS5CIP6OfN/2+c/OMxDhsajWypJgHjgYPjNNDyWLT+WpaWPMZkONJpZHDsSV3I/gN7bedNhG8+UDVhrf4ByV532Xm9s34PoBHKILySkCbSkF+oYMkO4aAdQOJuKA4CIDje1wL3YiFxkK/jmgnxtyy5ABEkt+U2ESF7sp/aMOByr93BLcAFVKEzZMHxG4VceZYE6glP0nu46xIrBJQZZa4+/Q6wSu6EJIzIbgKrekmDTkHlXHTDrjxYIUPbK0mRSoZIDEMnvwlEk7oDR+zjxtDxA/beNWDsEOyyJC5bLBd2GTBR+18BQKpTEcPdm94toAtdoTTLZZXZ8OvVXW23m3TH+LQsPsa2XAsR3b9v7gRnDyJxnQNagvzvYvqDwT5Y5aaftmS0Ot6hRwG6n3yvpnVO5YYRf9lgxD+SFJx5SLCAh5CqIM3DUogP6BsKy7SutbsJeskaYHErk+qAR6I+z/XudordG93JqaB6j3++wT5YpVsoMZERDKggsvGBdWiC9YsyV4f1r+gi5Y9BhpBoRnMos9+O+50viv/v77g4/usDYvVtx8ledMwys0kuB39OJ1/tD3UgaLqvFnjyl8VMpm59amQgun6dldwCl8Bu1479nw7eg2tk0RAnHhwyyYOc0JQJj2x6ZbnUKuFJ6X4jhTwYwXnzzxaaArDygy+wqAaqXpB1eTtzwM+RrIB5+thcLTg2xrjlKgb0gboCwknGUw5JYQREB1Bu9vYr2OvsF6Zttw/HY1rYG4rXbnUS9I7YEyW+/hNvBWaQu0crbN94ztwrGnEJBLW6ANW2O/9wtewe7cPQD1BSpXpK8z7CoPOreuyULfZwi7O2nLt2Nmu8emF15oGUCZEri0O2+yyaL9uloQEBdb8xzbtajNHtuPsIReBFCu5Nre/WVXk0W94l0QEFcaH5uboJg5bLK4LxUoU3KDfWP1im2JQJlecN6J+gAtFogrgXujXYE2QKgAkK0+x+p13iF3SQsgeWm2wNNH/2egnyuiRTPZ28Pb/p6MzTYp/BzQzw25ZYgOKInhQXlMzUSRAZXNviznAPcvchEBoXZsBD0RZEQENNU5pRcREDp68Vca5t3Khnm/0XSSCbfiGLBtWpWIgIrdKfGleba+tXrrGNNvWrxYF+n6dOnngIwvp0wGSHepBTL95eRFDmT6y1Vm+ssJRQZk+sthmf5yn0UEJL8EX1gWvF+aAaEhZ/rLMZn+cp9FBmT6y7WKL7iLZPrLCUQOxGX6yxFKKdA3ZIB0lxqg4hy8xm78waZVoNGcgycwXYDedutbE47q4abJkKvXM8y2zDmlf8UMEhEQ3odqzsEjlQIgmUdaXkRAKGrzK2n9qtT/Z87BQ23axE0g5hEdEFN9Dt60jYUUGgE0JDHsw7axtJ7ycp3txYpmMqU2m+vzc0CUtQhdZuoUGjJAYplewW8y+aEP+jqQ6RXco/F3yPQKHmamV/AHGSCxTK9gZTJAYqEhJ22Pmd9DQqFJQdp0c32kTQugGxyqpPBAq3y33LbhWachN028V3BUtbPWruZ0qlCizGaetmQaRgMgpuQMXjn09Go6OVWoPE2ftqByqlesujRulZRmS3BZ3epto3qUaMoogQsuB9hpUaI51pc7Q3QIsrMe1o0XrI4d0WVMy571E23lifvOjRUR0FhfLq9D5dkG6kJADSYFWhkgZeI1dife1nrhnkIaXyHyHVTJtURPobobzZlucUDvd0Nk2g+5FOJr+NbEtW2240N0jaXcHi5lQOnrAaeDK+5PX9rKhcPxRlosSAzE70YEvtOVQ1rB9nBSUlXPRQI06G6UJnnYS58kgAbcDT6kTg94pcjX0w4ojeEa+fUWszdbgXs4wq3xYGgJ9ICj+3kHfvcspSWQYInAhlQQtQ59EUp7oDXsOMjgqpGl3CFu1hrcIIJr523SEoi3C4gg6HiOPg9BLYGQipnufadjbSv3AMdbOUnoDoTU73DyadyvTxnQHahSmgxwe5jxBZwit4eLDgiJu0IXPiRbSa2GKXBMuZQA1Urh9TjBwV13roEsx8sOVaK4cYqBkDpXqbXZzt/yYtvd3vmisw/MY78d2ZDE77afSKcwZe+2YPlhLGoZIN1lgHSXAdJdBki1kkf8G6UxWaPKrNTsm64PX9TdytoDtraZtHcogXuED539BlBX20/ep2fgmEnuEXhvy4m5gfiBfR3Bkdx6qhOr4SX62UBq6/VIILSJvc+E1Ynt4dW0TXAB2SZM44CufuMCbDeEa5wfgJQmzP0PmxfbqE5kdyVsnVpYGWE7qVFA5WEV3Gz/Kt7rjZu3liGr5AqBcOm9geDyLGJ3NBoBxIZb1dhuC12lofUJAy6cXs2GeKVRDC+RRgChsx2cnmAhOnbecVp9foi7lbU1AgiFc/v2CAm3tdngRupbEqgBwp/NzGkchKlSMwBZ4F/maxWhHmjm027UA/V+llYGyAAZIDlNA+Ln5pcNIYTGlhiDP9u22U77REBKbbYFngGaaLMBoUYqSs2cmNvQ/xnoDkeFtaJUmjQpWEQlySo0Cai21YDSsnk1AugGwRsQsqpgtvj4lzRyUhhS6mKB40dZK49vsI0EQuKlLpee6ivLAX9QTSqdpgMhZVHTnuorXhB4muGukQBhlQWBn49K4AWBmm8VECuvvO+qUVUx/SsEQuotLcsnEorpfx4gpLK0rLnDGNkq1KED4BQx750/b0Eb7hspSSoVU3/QeK8tDah6f31q2L+IejlR5WLLiFwnhUDcTbrM/k4iB+In2hy7ZjFmVDsiRSIBqlyfrnT/TH7ddKDyZbnu2howv+c9Dqja39BzpMgX10YjgK7dCzzFTudQjQISBRpXbqBVfGEa0BcWbkM1AugGf5lHLBfZVK1xk8IC9H8G+rlg/c+lUwzQRPsmEHsfeaFeGYkRQC+4ZTuwWlCl2fxlq+bAyzEaAVSr2qf6ablQ7gmfeAaEjCYBYWVhqdD7GAam3KM6RNJAWH2r1WylylvnKoQjBarFY27dcKWXTj0qFQFh1QFFcQG6BetGqwI5zQCE1RcJYkt2j70Gik9P0cxAWAVcsG3duUWGgruescUAfQrON83Se7d+Oay6+2Zp3k9hBIS+HS+GxLEZxFpN2w4sCSB9ILBGAnGIE4TeQAi9ndPu0hgO8S0PG2sEkGCB98VlwifJASkxE1No6P8MxLPXuE27KmMeQ/EXp2gE0DJkgHSXAdJdPwYE8B+Tl/EuZx78MgAAAABJRU5ErkJggg==">
              </td>
              <td
                style="
                  width: 5%;
                  border-color: black;
                  border-style: solid;
                  overflow: hidden;
                  padding: 10px;
                  word-break: break-all;
                  white-space: normal;
                  border: 0px;
                  word-break: keep-all !important;
                "
                class=""
              >
                In connection with my request to be an authorized driver of a
                BMW Group (the "Company") vehicle, I consent to the release of
                my Motor Vehicle Records (MVR). I understand the Company will
                use these records in connection with matters of motor vehicle or
                driver safety. I further consent to and understand the
                following:
                <br />
                <ul>
                  <li>
                    I consent to the periodic review and evaluation of the MVR I
                    have provided to the Company during the time I am authorized
                    to operate a Company vehicle.
                  </li>
                  <br />
                  <li>
                    I have been provided with a copy of the BMW Group Employee
                    Vehicle Policy and agree to read and comply with the
                    requirements of the BMW Group Employee Vehicle Policy.
                  </li>
                  <br />
                  <li>
                    I understand that I am required to maintain a valid driver's
                    license while authorized to operate a Company vehicle.
                  </li>
                  <br />
                  <li>
                    I agree to immediately report to my family member who is
                    employed by the Company, and through whom I am requesting a
                    Company vehicle: (i) any driver's license suspension or
                    expiration; and/or (ii) any damage or accident involving
                    damage to a Company vehicle or any alcohol or drug-related
                    driving offense involving my use of the Company vehicle. I
                    understand my family member is obligated to report to the
                    Company within 48 hours any information covered under (i) or
                    (ii) above.
                  </li>
                  <br />
                  <li>
                    Where permitted, this Authorization shall remain in effect
                    during the time I am authorized to operate a Company vehicle
                    and reports may be ordered periodically during that time.
                  </li>
                  <br />
                </ul>
                This consent is given in satisfaction of Public Law 18 U.S.C.
                2721 et. seq., "Federal Drivers Privacy Protection Act," and
                applicable state law, and is intended to constitute “written
                consent" as required by state and federal law. I certify that
                the information provided is true and complete to the best of my
                knowledge. I understand that any falsification,
                misrepresentation, omission, or concealment of information may
                lead to disqualification from participation in the Company's
                vehicle program.
                <br />
                <br />
                <p>
                  Authorized Driver Name: ${authorizedDriverFormValue.firstName}
                  ${authorizedDriverFormValue.middleName} ${
                    authorizedDriverFormValue.lastName
                  }
                  ${authorizedDriverFormValue.suffix}
                </p>
                <p>Authorized Driver Signature:</p>
                <p>Date:</p>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <br />
    </main>
  </body>
</html>
`;

    return html;
  }

  // async getConsentPDF(
  //   generatedHtml: string
  // ): Promise<{ generatedHTML: string; base64File: string }> {
  //   try {
  //     if (generatedHtml) {
  //       // const parser = new DOMParser();
  //       // const doc = parser.parseFromString(generatedHtml, 'text/html');
  //       // const hiddenContainer = document.createElement('div');
  //       // hiddenContainer.style.position = 'fixed';
  //       // hiddenContainer.style.left = '-9999px';
  //       // hiddenContainer.style.top = '-9999px';
  //       // hiddenContainer.innerHTML = doc.body.innerHTML;
  //       // document.body.appendChild(hiddenContainer);
  //       // const pdfCanvas = await html2canvas(hiddenContainer, {
  //       //   scale: 1,
  //       // });
  //       // const imageData = pdfCanvas.toDataURL('image/png');
  //       const pdf = new jsPDF('p', 'mm', 'a4');
  //       // const pageWidth = pdf.internal.pageSize.getWidth();
  //       // const pageHeight = pdf.internal.pageSize.getHeight();
  //       // const imageOriginalWidth = pdfCanvas.width * (25.4 / 96);
  //       // const imageOriginalHeight = pdfCanvas.height * (25.4 / 96);
  //       // const widthScale = pageWidth / imageOriginalWidth;
  //       // const heightScale = pageHeight / imageOriginalHeight;
  //       // const scaleFactor = Math.min(widthScale, heightScale);
  //       // const finalImageWidth = imageOriginalWidth * scaleFactor;
  //       // const finalImageHeight = imageOriginalHeight * scaleFactor;
  //       // const marginX = (pageWidth - finalImageWidth) / 2;
  //       // const marginY = (pageHeight - finalImageHeight) / 2;
  //       const newHTML = generatedHtml;
  //       await pdf.html(generatedHtml, {
  //         margin: [2, 2, 2, 2],
  //         width: 240,
  //         html2canvas: {
  //           scale: 0.3,
  //         },
  //       });
  //       const pdfDataUri = pdf.output('datauristring');
  //       const base64Pdf = pdfDataUri.split(',')[1];
  //       return { generatedHTML: newHTML, base64File: base64Pdf };
  //     } else {
  //       return { generatedHTML: '', base64File: '' };
  //     }
  //   } catch (error) {
  //     return { generatedHTML: '', base64File: '' };
  //   }
  // }

  // async getConsentPDF(
  //   generatedHtml: string
  // ): Promise<{ generatedHTML: string; base64File: string }> {
  //   try {
  //     if (!generatedHtml) {
  //       return { generatedHTML: '', base64File: '' };
  //     }
  //     const parser = new DOMParser();
  //     const doc = parser.parseFromString(generatedHtml, 'text/html');
  //     const main = doc.querySelector('main') ?? doc.body;
  //     const hiddenContainer = document.createElement('div');
  //     hiddenContainer.style.position = 'fixed';
  //     hiddenContainer.style.left = '-10000px';
  //     hiddenContainer.style.top = '0';
  //     hiddenContainer.style.background = '#ffffff';
  //     hiddenContainer.style.width = '210mm';
  //     hiddenContainer.style.padding = '0';
  //     hiddenContainer.style.margin = '0';
  //     hiddenContainer.appendChild(main);
  //     document.body.appendChild(hiddenContainer);
  //     const canvas = await html2canvas(hiddenContainer, {
  //       scale: 1.5,
  //       useCORS: true,
  //       logging: false,
  //       scrollX: 0,
  //       scrollY: 0,
  //       windowWidth: hiddenContainer.scrollWidth,
  //       windowHeight: hiddenContainer.scrollHeight,
  //     });
  //     document.body.removeChild(hiddenContainer);
  //     const imgData = canvas.toDataURL('image/png');
  //     const pdf = new jsPDF('p', 'mm', 'a4');
  //     const pageWidth = pdf.internal.pageSize.getWidth();
  //     const pageHeight = pdf.internal.pageSize.getHeight();
  //     const imgWidthMm = (canvas.width * 25.4) / 96;
  //     const imgHeightMm = (canvas.height * 25.4) / 96;
  //     const maxContentWidth = pageWidth - 2 * 7;
  //     const maxContentHeight = pageHeight - 2 * 7;
  //     const widthScale = maxContentWidth / imgWidthMm;
  //     const heightScale = maxContentHeight / imgHeightMm;
  //     const scaleFactor = Math.min(widthScale, heightScale);
  //     const finalWidth = imgWidthMm * scaleFactor;
  //     const finalHeight = imgHeightMm * scaleFactor;
  //     const marginX = (pageWidth - finalWidth) / 2;
  //     const marginY = (pageHeight - finalHeight) / 2;
  //     pdf.addImage(imgData, 'PNG', marginX, marginY, finalWidth, finalHeight);
  //     const pdfDataUri = pdf.output('datauristring');
  //     const base64Pdf = pdfDataUri.split(',')[1];
  //     return { generatedHTML: generatedHtml, base64File: base64Pdf };
  //   } catch (error) {
  //     return { generatedHTML: '', base64File: '' };
  //   }
  // }

  async getConsentPDF(
    generatedHtml: string,
    authorizedDriver: any,
    employee: any,
    company: string,
    employeeStateProvince: string,
    authorizedDriverStateProvince: string,
    authorizedDriverRelationship: string
  ): Promise<{ generatedHTML: string; base64File: string }> {
    try {
      if (!generatedHtml) {
        return { generatedHTML: '', base64File: '' };
      }
      const doc = new jsPDF('p', 'mm', 'a4');
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const marginX = 10;
      const marginY = 15;
      const contentWidth = pageWidth - marginX * 2;
      const lineHeight = 5;
      let y = marginY;
      const ensureSpace = (h: number) => {
        if (y + h > pageHeight - marginY) {
          doc.addPage();
          y = marginY;
        }
      };
      const fullName = (f?: string, m?: string, l?: string, s?: string) =>
        [f, m, l, s].filter((v) => v && v.trim()).join(' ');
      const formatDate = (d: any): string => {
        if (!d) return '';
        if (d instanceof Date) {
          const mm = String(d.getMonth() + 1).padStart(2, '0');
          const dd = String(d.getDate()).padStart(2, '0');
          const yyyy = d.getFullYear();
          return `${mm}/${dd}/${yyyy}`;
        }
        return String(d);
      };
      // ---------- HEADER ----------
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(14);
      doc.text('BMW Group Employee Vehicle Program', pageWidth / 2, y, {
        align: 'center',
      });
      y += lineHeight + 1;
      doc.text(
        'Motor Vehicle Report Monitoring Consent Form',
        pageWidth / 2,
        y,
        {
          align: 'center',
        }
      );
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(10);
      y += lineHeight * 2;
      const headerLines = doc.splitTextToSize(
        'Vehicle Administration in conjunction with SambaSafety continuously monitors your Motor Vehicle Record (MVR). If there is a change in your MVR, it will be reviewed.',
        contentWidth
      );
      ensureSpace(headerLines.length * lineHeight);
      doc.text(headerLines, pageWidth / 2, y, { align: 'center' });
      y += headerLines.length * lineHeight + lineHeight;
      const verticalHooks = {
        willDrawCell: (data: any) => {
          if (
            data.section === 'body' &&
            data.column.index === 0 &&
            data.row.index === 0
          ) {
            data.cell.text = [];
          }
        },
        didDrawCell: (data: any) => {
          if (
            data.section === 'body' &&
            data.column.index === 0 &&
            data.row.index === 0
          ) {
            const raw: any = data.cell.raw;
            const text =
              raw && typeof raw === 'object' && 'content' in raw
                ? String(raw.content ?? '')
                : String(raw ?? '');
            const paddingX = 1.5;
            const paddingY = 2;
            const x = data.cell.x + data.cell.width - paddingX;
            const yy = data.cell.y + data.cell.height - paddingY;
            doc.saveGraphicsState();
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(6);
            doc.text(text, x, yy, { angle: 90 });
            doc.restoreGraphicsState();
          }
        },
      };
      // ========= 1) ASSOCIATE INFORMATION =========
      const associateRows: any[][] = [];
      associateRows.push([
        {
          content: 'Associate Information',
          rowSpan: 3,
          styles: { fontStyle: 'bold', valign: 'middle', halign: 'center' },
        },
        'Associate Name:',
        fullName(
          employee.firstName,
          employee.middleName,
          employee.lastName,
          employee.suffix
        ),
        'Associate No.:',
        employee.employeeId || '',
        'Telephone:',
        { content: '', colSpan: 3 },
      ]);
      associateRows.push([
        'Note:',
        {
          content:
            "Please provide driver’s license details below for each vehicle request. It is the associate’s responsibility to advise Vehicle Administration or Human Resources of a suspended or revoked driver's license, in writing, within 48 hours of DMV notification.",
          colSpan: 7,
        },
      ]);
      associateRows.push([
        'Driver License No.:',
        employee.driverLicenseNumber || '',
        'Expiry Date (mm/dd/yyyy):',
        formatDate(employee.expiryDate),
        'Issuing State:',
        employeeStateProvince || '',
        'Birth Date (mm/dd/yyyy):',
        formatDate(employee.dateOfBirth),
      ]);
      autoTable(doc, {
        startY: y,
        theme: 'grid',
        styles: {
          font: 'helvetica',
          fontSize: 9,
          cellPadding: 2,
          valign: 'middle',
        },
        margin: { left: marginX, right: marginX },
        columnStyles: {
          0: { cellWidth: 10 },
          1: { cellWidth: (contentWidth - 10) / 8 },
          2: { cellWidth: (contentWidth - 10) / 8 },
          3: { cellWidth: (contentWidth - 10) / 8 },
          4: { cellWidth: (contentWidth - 10) / 8 },
          5: { cellWidth: (contentWidth - 10) / 8 },
          6: { cellWidth: (contentWidth - 10) / 8 },
          7: { cellWidth: (contentWidth - 10) / 8 },
          8: { cellWidth: (contentWidth - 10) / 8 },
        },
        body: associateRows,
        willDrawCell: verticalHooks.willDrawCell,
        didDrawCell: verticalHooks.didDrawCell,
      });
      y = (doc as any).lastAutoTable.finalY + 5;
      // ========= 2) PRIMARY / AUTHORIZED DRIVER INFORMATION =========
      const driverRows: any[][] = [];
      const isPrimary = authorizedDriver.primaryDriverInd === 'Y';
      const driverStrip = isPrimary
        ? 'Primary Driver Information'
        : 'Authorized Driver Information';
      const driverNameLabel = isPrimary
        ? 'Primary Driver Name:'
        : 'Authorized Driver Name:';
      driverRows.push([
        {
          content: driverStrip,
          rowSpan: 2,
          styles: { fontStyle: 'bold', valign: 'middle', halign: 'center' },
        },
        driverNameLabel,
        fullName(
          authorizedDriver.firstName,
          authorizedDriver.middleName,
          authorizedDriver.lastName,
          authorizedDriver.suffix
        ),
        'Relationship to Associate:',
        {
          content: authorizedDriverRelationship || '',
          colSpan: 5,
        },
      ]);
      driverRows.push([
        'Driver License No.:',
        authorizedDriver.driverLicenseNumber || '',
        'Expiry Date (mm/dd/yyyy):',
        formatDate(authorizedDriver.expiryDate),
        'Issuing State:',
        authorizedDriverStateProvince || '',
        'Birth Date (mm/dd/yyyy):',
        formatDate(authorizedDriver.dateOfBirth),
      ]);
      autoTable(doc, {
        startY: y,
        theme: 'grid',
        styles: {
          font: 'helvetica',
          fontSize: 9,
          cellPadding: 2,
          valign: 'middle',
        },
        margin: { left: marginX, right: marginX },
        columnStyles: {
          0: { cellWidth: 10 },
          1: { cellWidth: (contentWidth - 10) / 8 },
          2: { cellWidth: (contentWidth - 10) / 8 },
          3: { cellWidth: (contentWidth - 10) / 8 },
          4: { cellWidth: (contentWidth - 10) / 8 },
          5: { cellWidth: (contentWidth - 10) / 8 },
          6: { cellWidth: (contentWidth - 10) / 8 },
          7: { cellWidth: (contentWidth - 10) / 8 },
          8: { cellWidth: (contentWidth - 10) / 8 },
        },
        body: driverRows,
        willDrawCell: verticalHooks.willDrawCell,
        didDrawCell: verticalHooks.didDrawCell,
      });
      y = (doc as any).lastAutoTable.finalY + 5;
      // ========= 3) MVR AUTHORIZATION FOR AUTHORIZED DRIVERS =========
      const bullets = [
        'I consent to the periodic review and evaluation of the MVR I have provided to the Company during the time I am authorized to operate a Company vehicle.',
        'I have been provided with a copy of the BMW Group Employee Vehicle Policy and agree to read and comply with the requirements of the BMW Group Employee Vehicle Policy.',
        "I understand that I am required to maintain a valid driver's license while authorized to operate a Company vehicle.",
        "I agree to immediately report to my family member who is employed by the Company, and through whom I am requesting a Company vehicle: (i) any driver's license suspension or expiration; and/or (ii) any damage or accident involving damage to a Company vehicle or any alcohol or drug-related driving offense involving my use of the Company vehicle. I understand my family member is obligated to report to the Company within 48 hours any information covered under (i) or (ii) above.",
        'Where permitted, this Authorization shall remain in effect during the time I am authorized to operate a Company vehicle and reports may be ordered periodically during that time.',
      ];
      const consentIntro =
        'In connection with my request to be an authorized driver of a BMW Group (the "Company") vehicle, I consent to the release of my Motor Vehicle Records (MVR). I understand the Company will use these records in connection with matters of motor vehicle or driver safety. I further consent to and understand the following:';
      const closing =
        'This consent is given in satisfaction of Public Law 18 U.S.C. 2721 et. seq., "Federal Drivers Privacy Protection Act," and applicable state law, and is intended to constitute “written consent" as required by state and federal law. I certify that the information provided is true and complete to the best of my knowledge. I understand that any falsification, misrepresentation, omission, or concealment of information may lead to disqualification from participation in the Company\'s vehicle program.';
      const bulletText = bullets.map((b) => `• ${b}`).join('\n\n');
      const consentCell = [consentIntro, '', bulletText, '', closing].join(
        '\n\n'
      );
      const signatureCell = [
        `Authorized Driver Name: ${fullName(
          authorizedDriver.firstName,
          authorizedDriver.middleName,
          authorizedDriver.lastName,
          authorizedDriver.suffix
        )}`,
        '',
        'Authorized Driver Signature:',
        '',
        'Date:',
      ].join('\n');
      const consentRows: any[][] = [
        [
          {
            content: 'MVR Authorization for Authorized Drivers',
            rowSpan: 2,
            styles: {
              fontStyle: 'bold',
              valign: 'middle',
              halign: 'center',
            },
          },
          consentCell,
        ],
        [signatureCell],
      ];
      autoTable(doc, {
        startY: y,
        theme: 'grid',
        styles: {
          font: 'helvetica',
          fontSize: 9,
          cellPadding: 2,
          valign: 'top',
        },
        margin: { left: marginX, right: marginX },
        columnStyles: {
          0: { cellWidth: 10 },
          1: { cellWidth: contentWidth - 10 },
        },
        body: consentRows,
        willDrawCell: verticalHooks.willDrawCell,
        didDrawCell: verticalHooks.didDrawCell,
      });
      const pdfDataUri = doc.output('datauristring');
      const base64Pdf = pdfDataUri.split(',')[1] || '';
      return { generatedHTML: generatedHtml, base64File: base64Pdf };
    } catch (err) {
      return { generatedHTML: generatedHtml, base64File: '' };
    }
  }
}
